import { jsxs as n, jsx as a } from "react/jsx-runtime";
import { ShareButtonListItem as i, ShareIcon as S, CopyIcon as u, CustomDropdownRoot as y, CustomDropdownList as T } from "./style.js";
import { DealAction as p } from "../../../types/Deal/index.js";
import { useTranslation as f } from "../../../hooks/useTranslation/index.js";
import { Dropdown as w } from "../../Dropdown/index.js";
import { useToast as L } from "../../../contexts/Toast/index.js";
import { BannerType as _ } from "../../../components/Banner/index.js";
import { Whatsapp as D, Copy as x } from "@pelando/fontawesome/icons";
import { getShareContent as I } from "./index.js";
import { DropdownListSide as k } from "../../Dropdown/components/DropdownList/index.js";
function j({
  id: t,
  className: l,
  isInactive: r,
  dispatch: e,
  height: m,
  padding: s,
  marginBottom: c,
  locale: d
}) {
  const { t: o } = f("common"), { showToast: h } = L(), C = () => {
    e({ type: p.CLICK_TO_SHARE, payload: { id: t } });
  }, b = [
    /* @__PURE__ */ n(
      i,
      {
        onClick: () => {
          e({ type: p.CLICK_TO_WHATSAPP_SHARE, payload: { id: t } });
        },
        children: [
          /* @__PURE__ */ a(
            S,
            {
              icon: D,
              "aria-label": o("deal-whatsapp-icon-aria-label"),
              "aria-disabled": r
            }
          ),
          "Whatsapp"
        ]
      },
      "whatsapp"
    ),
    /* @__PURE__ */ n(
      i,
      {
        onClick: () => {
          e({ type: p.CLICK_TO_COPY_LINK, payload: { id: t } }), h({
            text: o("copied-link-button-label-text"),
            bannerType: _.SUCCESS
          });
        },
        children: [
          /* @__PURE__ */ a(
            u,
            {
              icon: x,
              "aria-label": o("deal-whatsapp-icon-aria-label"),
              "aria-disabled": r
            }
          ),
          o("copy-link-button-label-text")
        ]
      },
      "copy"
    )
  ];
  return /* @__PURE__ */ n(y, { className: l, onOpen: C, children: [
    /* @__PURE__ */ a(w.TriggerButton, { children: I({
      ariaLabel: o("deal-whatsapp-icon-aria-label"),
      isInactive: r,
      height: m,
      padding: s,
      marginBottom: c,
      locale: d
    }) }),
    /* @__PURE__ */ a(T, { omitBreathingSpace: !0, side: k.LEFT, children: b })
  ] });
}
export {
  j as DealShareButtonDropdown
};
